import httpRequest from 'httpRequest'
import { CompanyLicenseContract, ExtendLicenseResultContract } from 'models'

const LICENSE_PREFIX = '/company/licenses'

const licenseService = {
    renewLicense: () =>
        httpRequest.get<ExtendLicenseResultContract>(`${LICENSE_PREFIX}/renew`),
    getEmailQuotaAmount: () =>
        httpRequest.get<number>(`${LICENSE_PREFIX}/email-quota`),
    getCurrentLicense: () =>
        httpRequest.get<CompanyLicenseContract>(`${LICENSE_PREFIX}/current`),
}

export default licenseService
